import TableChunk from './TableChunk';

export default TableChunk;
